import React, { useState, useEffect } from "react"
import DropDownSelect from "aldoo-ra/DropdownSelect"
import Input from "aldoo-ra/Input"
import useProductEditorTexts from "../useProductEditorTexts"

export default function SeatsEditor({
  onChange,
  value,
  field,
  readOnly = false,
}) {
  const t = useProductEditorTexts()
  const getSeatType = (val) => {
    return (val === undefined || val === null || val === 0) ? "license_model" : "custom"
  }
  
  const [seatType, setSeatType] = useState(() => getSeatType(value))
  const [customSeats, setCustomSeats] = useState(() => {
    return (value && value > 0) ? value : 1
  })
  const [hasUserInteracted, setHasUserInteracted] = useState(false)

  // Options for the dropdown
  const seatOptions = [
    { value: "license_model", label: t`Use License Model Seats` },
    { value: "custom", label: t`Custom` }
  ]

  // Handle seat type change
  const handleSeatTypeChange = (selectedOption) => {
    // Handle case where selectedOption might be an array
    const option = Array.isArray(selectedOption) ? selectedOption[0] : selectedOption
    const newType = option?.value
    setSeatType(newType)
    setHasUserInteracted(true)
    
    if (newType === "license_model") {
      // Set to 0 to use license model default
      console.log('Calling onChange with 0')
      onChange?.(0)
    } else {
      // Set to custom value
      console.log('Calling onChange with customSeats:', customSeats)
      onChange?.(customSeats)
    }
  }

  // Handle custom seats number change
  const handleCustomSeatsChange = (event) => {
    const inputValue = event.target.value
    
    // Allow empty string during typing
    if (inputValue === "") {
      setCustomSeats("")
      setHasUserInteracted(true)
      // Don't call onChange yet, let the user finish typing
      return
    }
    
    const numValue = parseInt(inputValue)
    if (!isNaN(numValue) && numValue >= 1) {
      setCustomSeats(numValue)
      setHasUserInteracted(true)
      
      if (seatType === "custom") {
        onChange?.(numValue)
      }
    }
  }

  // Handle blur to ensure we have a valid value when user finishes editing
  const handleCustomSeatsBlur = () => {
    if (customSeats === "" || customSeats < 1) {
      // Set to minimum valid value if empty or invalid
      setCustomSeats(1)
      if (seatType === "custom") {
        onChange?.(1)
      }
    }
  }

  // Update local state when external value changes (only if user hasn't interacted)
  useEffect(() => {
    if (!hasUserInteracted) {
      const newType = getSeatType(value)
      setSeatType(newType)
      if (value && value > 0) {
        setCustomSeats(value)
      }
    }
  }, [value, hasUserInteracted])

  // Set initial value
  useEffect(() => {
    const initialValue = (value === undefined || value === null || value === 0) ? 0 : value
    onChange?.(initialValue)
  }, [])

  return (
    <div className="seats-editor">
      <div className="flex flex-col gap-3">
        {/* Seat Type Dropdown */}
        <DropDownSelect
          variant="admin_highlighted"
          disabled={readOnly}
          options={seatOptions}
          placeholder={t`Select seat configuration...`}
          className="flex-grow text-admin_text bg-admin_paper"
          value={seatOptions.find(opt => opt.value === seatType) || seatOptions[0]}
          onChange={handleSeatTypeChange}
        />
        
        {/* Custom Seats Input */}
        {seatType === "custom" && (
          <div className="flex flex-col gap-2">
            <label className="text-sm text-admin_text_secondary">
              {t`Number of seats:`}
            </label>
            <Input
              variant="admin"
              readOnly={readOnly}
              type="number"
              min={1}
              value={customSeats}
              onChange={handleCustomSeatsChange}
              onBlur={handleCustomSeatsBlur}
              className="w-32"
              placeholder="1"
            />
          </div>
        )}

      </div>
    </div>
  )
}